<div *ngIf="valueController" class="user-picker-customfield" [formGroup]="valueController">
  <mat-checkbox formControlName="boolValue">{{ label }}</mat-checkbox>

  <mat-form-field appearance="outline" *ngIf="valueController.get('boolValue').value">
    <mat-label>{{ 'FOR_WHOM_METRIC' | translate }}</mat-label>
    <mat-select matNativeControl formControlName="userValue">
      <div class="field-container">
        <mat-form-field>
          <mat-label>{{ 'SEARCH' | translate }}</mat-label>
          <input matInput [formControl]="userSearchControl">
          <mat-icon
            *ngIf="userSearchControl?.value"
            style="cursor: pointer"
            matSuffix
            (click)="$event.stopPropagation(); clearSearch()"
          >close</mat-icon>
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
      <mat-option *ngFor="let user of usersOnSearch || users" [value]="user.id">
        {{ fullName(user) }}
      </mat-option>
    </mat-select>
    <mat-hint>{{ 'FOR_WHOM_METRIC_HINT' | translate }}</mat-hint>
  </mat-form-field>
</div>
